import lodash from 'lodash'
import moment from 'moment'
import { filter } from '../../../../utils/search'
import Base from '../base.store'

const baseUrl = '/api/v1/security/users'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        changePassword(context, { data, config }) {
            return base.request.put(`${baseUrl}/change-password`, data, { ...config })
        },
        meProfile(context, { config }) {
            return base.request.get(`${baseUrl}/me/profile`, { ...config })
        },
        meProfileUpdate(context, { data, config }) {
            return base.request.put(`${baseUrl}/me/profile`, data, { ...config })
        },
        meChangePassword(context, { data, config }) {
            return base.request.put(`${baseUrl}/me/change-password`, data, { ...config })
        },
        hasIdCard(context, {  idCard, idIgnore, config }) {
            return base.request.post(`${baseUrl}/has-id-card`, { idCard, id: idIgnore }, { ...config });
        },
        checkIdTax(context, { idTax, config }) {
            return base.request.post(`${baseUrl}/check-id-tax`, { idTax }, { ...config });
        },
        checkIdCardSystem(context, { data, config }) {
            return base.request.post(`${baseUrl}/check-id-card-system`, data, { ...config })
        },
        cacheFindAll(context, { searchQuery }) {
            let force = false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const whereFilter = []
            if(searchQuery) {
                whereFilter.push(
                    { name: 'fullName', operator: 'like', value: searchQuery },
                    { logic: 'OR', name: 'idCard', operator: 'like', type: "String", value: searchQuery },
                )
            }
            const sort = [{ name: 'fullName', type: 'asc' }]
            const list = context.state.list || []
            if (list.length > 0 && !force) {
                return filter({ list, where: whereFilter, sort })
            }
            return context.dispatch('findAll',
                {
                    criteria: {
                        select: [
                            "*", "refPersonType.*", "refNationality.*", "refTitle.*",
                            'id', 'fullName', 'refTitle.value', 'refImage.url',
                        ],
                        children: [
                            {
                                name: "addresses",
                                select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                                page: 0,
                                size: 1,
                            },
                        ]
                    }
                })
                    .then(list => filter({ list, where: whereFilter, sort }))
        },
        cacheFindAllOfficerUser(context, { searchQuery }) {
            let force = false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const whereFilter = [{ name: 'isOfficer', type: "Boolean", operator: "=", value: true }]
            if(searchQuery) {
                whereFilter.push(
                    { name: 'fullName', operator: 'like', value: searchQuery },
                    { logic: 'OR', name: 'idCard', operator: 'like', type: "String", value: searchQuery },
                )
            }
            const sort = [{ name: 'fullName', type: 'asc' }]
            const list = context.state.list || []
            if (list.length > 0 && !force) {
                return filter({ list, where: whereFilter, sort })
            }
            return context.dispatch('findAll',
                {
                    criteria: {
                        select: [
                            "*", "refPersonType.*", "refNationality.*", "refTitle.*",
                            'id', 'fullName', 'refTitle.value', 'refImage.url',
                        ],
                    }
                })
                .then(list => filter({ list, where: whereFilter, sort }))
        },
    },
    mutations: {
        ...base.mutations
    },
}
